import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import { requestCollection } from './Actions';
import ExtraCollectionChargeModalComponent from './ExtraCollectionChargeModalComponent';
import { PaymentRecordDetail } from './Types';

type OwnProps = {
  readonly modalOpen: boolean
  readonly toggleExtraCollectionChargeModalOpen: () => void
  readonly togglePaymentDetailsModalOpen: () => void
  readonly paymentRecordDetail: PaymentRecordDetail
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    requestCollection: (paymentHistoryId: number) => dispatch(requestCollection(paymentHistoryId))
  };
};

const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
  return {
    paymentsState: state.paymentsState,
    modalOpen: ownProps.modalOpen,
    toggleExtraCollectionChargeModalOpen: ownProps.toggleExtraCollectionChargeModalOpen,
    togglePaymentDetailsModalOpen: ownProps.togglePaymentDetailsModalOpen,
    paymentRecordDetail: ownProps.paymentRecordDetail
  };
};

const ExtraCollectionChargeModal =
  ReactRedux.connect(mapStateToProps, mapDispatchToProps)(ExtraCollectionChargeModalComponent);

export default ExtraCollectionChargeModal;



// WEBPACK FOOTER //
// ./src/payments/ExtraCollectionChargeModal.tsx